const MARKERS_DATA_SOURCE = {
  SUPPLIER_AND_PICK_UP_LOCATION_ADDRESS_FROM_DEAL:
    'supplier_and_pick_up_location_address_from_deal',
  SUPPLIER_AND_PICK_UP_LOCATION_ADDRESS_WITH_PRICE_FROM_DEAL:
    'supplier_and_pick_up_location_address_with_price_from_deal',
  MULTIPLE_SUPPLIERS_AND_DESTINATION_NAME_FROM_SUPPLIER:
    'multiple_suppliers_and_destination_name_from_supplier',
  HOTELS_DEAL_INFORMATION_FROM_DEAL: 'hotels_deal_information_from_deal',
  POI_INFORMATION_FROM_HOTELS_INDICATIVE:
    'poi_information_from_hotels_indicative',
} as const;

export default MARKERS_DATA_SOURCE;
